import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import TermsOfService from "@/components/TermsOfService";
import Support from "@/components/Support";
import LandingPage from "@/components/LandingPage";
import GolfSkinsPrivacy from "@/components/GolfSkinsPrivacy";

import GolfSkinsSupport from "@/components/GolfSkinsSupport";
import VideoInspectPrivacy from "@/components/VideoInspectPrivacy";
import VideoInspectTerms from "@/components/VideoInspectTerms";
import VideoInspectSupport from "@/components/VideoInspectSupport";
import WhosRankingPrivacy from "@/components/WhosRankingPrivacy";
import WhosRankingTerms from "@/components/WhosRankingTerms";
import WhosRankingSupport from "@/components/WhosRankingSupport";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<div />} />
        <Route path="/hearingdecibelpro" element={<LandingPage />} />
        <Route path="/hearingdecibelpro/privacy" element={<PrivacyPolicy />} />
        <Route path="/hearingdecibelpro/terms" element={<TermsOfService />} />
        <Route path="/hearingdecibelpro/support" element={<Support />} />
        <Route path="/golfskins/privacy" element={<GolfSkinsPrivacy />} />
        <Route path="/golfskins/support" element={<GolfSkinsSupport />} />
        <Route path="/videoinspect/privacy" element={<VideoInspectPrivacy />} />
        <Route path="/videoinspect/terms" element={<VideoInspectTerms />} />
        <Route path="/videoinspect/support" element={<VideoInspectSupport />} />
        <Route path="/whosrankingong" element={<WhosRankingPrivacy />} />
        <Route path="/whosrankingong/privacy" element={<WhosRankingPrivacy />} />
        <Route path="/whosrankingong/terms" element={<WhosRankingTerms />} />
        <Route path="/whosrankingong/support" element={<WhosRankingSupport />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
